import { render } from "./ManufacturerSelect.vue?vue&type=template&id=90d11240"
import script from "./ManufacturerSelect.vue?vue&type=script&lang=js"
export * from "./ManufacturerSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/v2/ManufacturerSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "90d11240"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('90d11240', __exports__)) {
    api.reload('90d11240', __exports__)
  }
  
  module.hot.accept("./ManufacturerSelect.vue?vue&type=template&id=90d11240", () => {
    api.rerender('90d11240', render)
  })

}


export default __exports__